import { sortByName, createOptionsSelector } from '@mews-commander/utils';
import { getActiveAccountingCategories } from '../ducks/accountingCategories';

export const getAccountingCategoriesOptions = createOptionsSelector(getActiveAccountingCategories, {
    sortFunction: sortByName,
});
